module.exports = __webpack_public_path__ + "img/storage.3c8faef2.png";